import axios from 'axios';

export const api = axios.create({
   // baseURL: 'http://192.168.0.62:3333'
  // baseURL:'http://18.219.112.46:3333'

 baseURL: 'https://api.thinkmetas.babita.com.br'//'http://177.70.12.42:3333'
 
//baseURL:'https://api.thinkfornecedores.com.br/'

// baseURL: 'http://192.168.0.160:3333'

});

export const api2 = axios.create({
 baseURL: 'https://api.backsankhya.babita.com.br'//'http://177.70.12.42:3336'
 

});

export default api;